import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { UserProfileCreateRequest } from '../../../types/user'
import { useApiPostMutation } from '../useApi'

export const useUserProfileCreate = () => {
  const queryClient = useQueryClient()

  const mutation = useApiPostMutation<ApiResponse, UserProfileCreateRequest>()

  return {
    ...mutation,
    mutateAsync: async (data: UserProfileCreateRequest) => {
      const result = await mutation.mutateAsync({
        url: '/user/profile/create',
        data,
      })
      queryClient.invalidateQueries({ queryKey: ['userProfile'] })
      return result
    },
    mutate: (data: UserProfileCreateRequest) => {
      mutation.mutate(
        {
          url: '/user/profile/create',
          data,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['userProfile'] })
          },
        }
      )
    },
  }
}
